enum sellerStatus {
    Processing = 'PROCESSING',
    Approved = 'APPROVED',
    Reproved = 'REPROVED',
    Pending = 'PENDING',
    Disabled = 'DISABLED',
}

export default sellerStatus;
